module.exports = __webpack_public_path__ + "static/media/RenewableGreenEnergy.39e64455.svg";